/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc7Inputs */

const en_fc_tut_sc7 = /** @type {(inputs: Fc_Tut_Sc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend edit to playhead`)
};

/**
* | output |
* | --- |
* | "Extend edit to playhead" |
*
* @param {Fc_Tut_Sc7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc7 = /** @type {((inputs?: Fc_Tut_Sc7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc7(inputs)
});
export { fc_tut_sc7 as "fc.tut.sc7" }